import { render } from "./TaskAttachments.vue?vue&type=template&id=431ebc2c"
import script from "./TaskAttachments.vue?vue&type=script&lang=js"
export * from "./TaskAttachments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__